import React from 'react'
import styled from '@emotion/styled'
import { SelectField } from '@mobi/component-library/Legacy/Select'
import { TextArea } from '@mobi/component-library/Selection&Input/Inputs/TextArea'
import { spacing } from '@mobi/component-library/Foundations'
import { Button } from '@mobi/component-library/Base/Buttons'
import { NoticeBox } from '@core/Components/NoticeBox'
import { useFeedbackFormQuery } from './helpers/useFeedbackFormQuery'
import { handleFormSubmission } from './helpers/handleFormSubmission'

export const FeedbackForm: React.FC<{ accountNumber: number }> = ({ accountNumber }) => {
  const [isBusy, setIsBusy] = React.useState(false)
  const [subject, setSubject] = React.useState<string>('')
  const [message, setMessage] = React.useState<string>('')

  const { hasApiErrored, shouldDisableSubmission, subjects, contactDetails } =
    useFeedbackFormQuery(accountNumber)

  if (hasApiErrored || (!shouldDisableSubmission && !subjects)) {
    return (
      <NoticeBox
        title='Feeback Form is Unavailable'
        subtitle="Sorry, we're unable to connect to the server. Please try again later."
        noticeBoxType='Error'
      />
    )
  }

  const subjectValue = subject || (subjects ? subjects[0] : '')
  const errorMessage =
    message.length > 1 && message.length < 20 ? 'Message must contain at least 20 characters' : ''

  const handleSubmit = () => {
    if (!message || message.length < 20) return
    handleFormSubmission({
      message,
      subject: subjectValue,
      accountNumber,
      contactDetails,
      setMessage,
      setIsBusy,
    })
  }

  return (
    <FeedbackFormStyled data-testid='feedback-form'>
      <SelectField
        name='Subject'
        value={subjectValue}
        onChange={e => setSubject(e.target.value)}
        required
        options={subjects}
        data-testid='feedback-subjects'
      />

      <TextArea
        name='Message'
        label='Message'
        isInvalid={!!errorMessage}
        helpText={errorMessage}
        onChange={e => setMessage(e.target.value)}
        value={message}
        testId='feedback-message'
      />

      <Button
        color='primary'
        onClick={handleSubmit}
        isLoading={isBusy || shouldDisableSubmission}
        disabled={isBusy || shouldDisableSubmission}
        data-testid='feedback-submit'
      >
        Send Message
      </Button>
    </FeedbackFormStyled>
  )
}

// ======
// Styles
// ======

const FeedbackFormStyled = styled.div({
  display: 'flex',
  flexDirection: 'column',
  gap: spacing.sm,
  margin: '0.5rem 1rem',
  paddingBottom: spacing.lg,
})
